import { TableRow } from "@mui/material";
import { styled } from "@mui/system";

export const StandardTableRow = styled(TableRow)(({ theme }) => ({
  width: "100%",
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
